<template>
  <div>
    <h1 v-html="heading" />
    <section>
      <article class="flow-group">
        <div class="header-with-icon push-down">
          <div id="StartDate" class="control">
            <h-3-and-tooltip
              :h3="proposalModel.Label_StartDate"
              :tooltip="proposalModel.Tooltip_StartDate"
            />
            <Field
              name="StartDate"
              :model-value="vueModel.AdditionalInformation.StartDate"
              :rules="{ required: true }"
              :label="decodeHtml(proposalModel.FieldName_StartDate)"
            >
              <date-picker
                id="startdate"
                name="StartDate"
                :min-date="currentDate"
                :date="vueModel.AdditionalInformation.StartDate"
                class="datepicker"
                :placeholder="proposalModel.PlaceholderSelectStartDate"
                @date-changed="dateChanged"
              />
            </Field>
            <ValidationError name="StartDate" />

            <div class="info-box is-shown info-box-align-left">
              <p v-html="proposalModel.StartDateInfoBoxText" />
            </div>
          </div>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import mixin from './CheckoutMixin.vue';
import ValidationError from '@/components/UI/ValidationError.vue';
import H3AndTooltip from '@/components/UI/H3AndTooltip.vue';
import DatePicker from '@/components/UI/Pickadate.vue';
import Utility from '@/common/UtilityFunctions';

export default {
  name: 'SalaryProtection',
  components: {
    H3AndTooltip,
    ValidationError,
    DatePicker
  },
  mixins: [mixin],
  props: {
    externalVueModel: {
      type: Object,
      default() {
        return {};
      }
    },
    proposalModel: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      vueModel: this.externalVueModel
    };
  },
  computed: {
    heading() {
      if (
        this.vueModel &&
        this.vueModel.Name &&
        this.proposalModel &&
        this.proposalModel.LabelExtraInformationForYour
      ) {
        return `${
          this.proposalModel.LabelExtraInformationForYour
        } ${this.vueModel.Name.toLowerCase()}`;
      }

      return '';
    }
  },
  watch: {
    vueModel: {
      handler() {
        this.$emit('vue-model-updated', this.vueModel);
      },
      deep: true
    }
  },
  methods: {
    decodeHtml: Utility.decodeHtml,
    dateChanged(param) {
      this.vueModel.AdditionalInformation.StartDate = param;
    }
  }
};
</script>
